// 课件状态
export const CW_STATUS_DEL = 0  // 删除
export const CW_STATUS_PLAN = 1  // 准备
export const CW_STATUS_PRE = 2  // 预告
export const CW_STATUS_PUB = 3 // 发布
